import XLRLogger from 'src/common/helpers/logger';
import { store } from 'src/common/redux/configure-store';
import { MICRActions } from 'src/common/redux/reducers/micr-reducer';
import { RdsResponseType } from 'src/devices/device-enums';
import { DeviceResponse } from 'src/devices/rds-connection';
import { sendCheckDetailsRequest } from 'src/tender-check/business-logic/services/micr-service';
import { TenderParameters } from 'src/tendering/interfaces/tender-parameters';
import { parseCheckData } from './micr-utilities';

export const handleMICRMessage = (response: DeviceResponse) => {
  const deviceName = response.metaDataMap.logicalName || '';
  if (response.error || !deviceName) {
    XLRLogger.error({
      message: 'RDS MICR Error',
      source: 'devices/micr-operations.ts',
      data: response,
    });
    return;
  }

  switch (response.responseType) {
    case RdsResponseType.HEALTH_CHECK_SUCCESS:
    case RdsResponseType.HEALTH_CHECK_FAILURE:
      break;
    case RdsResponseType.DATA:
      store.dispatch(MICRActions.setMICRData(response.metaDataMap));
      break;
    default:
      XLRLogger.info({
        message: 'Unrecognized message from MICR',
        source: 'devices/micr-operations.ts',
        data: response,
      });
      return;
  }

  XLRLogger.debug({
    message: `MICR Status: ${response.message}`,
    source: 'devices/micr-operations.ts',
    data: response,
  });
};

export const getCheckDetails = async (): Promise<TenderParameters[]> => {
  const deviceResponse = await sendCheckDetailsRequest('get-check-details');
  if (deviceResponse.success) {
    store.dispatch(MICRActions.setMICRData(deviceResponse.metaDataMap));
    return parseCheckData(deviceResponse);
  } else {
    throw new Error(deviceResponse.message);
  }
};
